import { getSupplierCustomer } from "../../services/supplier-customers";

/** Hydrate legacy scalar references for supplier-owned PDF headers, without changing document layout. */
export async function resolveSupplierPdfOrder(order: any, user: any) {
  let supplierCustomer = order.supplier_customer;
  if (!order.prior_order && supplierCustomer && typeof supplierCustomer !== "object") {
    const response = await getSupplierCustomer(Number(supplierCustomer));
    if (Number(response.data?.id) !== Number(supplierCustomer)) throw new Error("PDF customer does not match order");
    supplierCustomer = response.data;
  }
  const creator = order.created_by && typeof order.created_by !== "object"
    ? Number(order.created_by) === Number(user?.id) ? user : null
    : order.created_by;
  return { ...order, supplier_customer: supplierCustomer, created_by: creator };
}
